import React from "react";
import { useLocation } from "react-router-dom";
import { LoginPage } from "./pages/login";
import { AdminPage } from "./pages/admin";
import {
  createMuiTheme,
  ThemeProvider,
  makeStyles
} from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import { lightGreen } from "@material-ui/core/colors";
import { Auth } from "aws-amplify";
import { rudderInitialize } from "./utils/rudderstack/init";
import { parseLocation } from "./utils/rudderstack/parseLocation";

rudderInitialize();
const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  }
}));

const darkTheme = createMuiTheme({
  palette: {
    type: "dark",
    primary: lightGreen
  }
});

function App() {
  const [session, setSession] = React.useState<boolean>();
  const classes = useStyles();
  const location = useLocation();
  
  
  React.useEffect(() => {
    Auth.currentSession()
      .then((s) => setSession(!!s))
      .catch(() => setSession(false));
  }, []);
  
  React.useEffect(() => {
    parseLocation({ path: location.pathname });
  }, [location]);
  
  if (session === undefined) {
    return null;
  }

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <div className={classes.root}>
        {session ? (
          <AdminPage />
        ) : (
          <LoginPage loggedIn={() => setSession(true)} />
        )}
      </div>
    </ThemeProvider>
  );
}

export default App;
